<section class="page">

  <!-- HERO -->
  <header class="hero">
    <div class="hero__bg">
      <div class="hero__orb hero__orb--primary"></div>
      <div class="hero__orb hero__orb--secondary"></div>
    </div>
    <div class="hero__content">
      <div class="hero__kicker">Partiri Blog</div>
      <h1 class="hero__title">Notes on EU infrastructure and the platform</h1>
      <p class="hero__subtitle">Data residency, GDPR, the Kubernetes stack underneath Partiri, and the European PaaS landscape.</p>
    </div>
  </header>

  <section class="section timeline">
    @for (post of posts; track post.slug) {
      <a class="card--post" [routerLink]="['/blog', post.slug]">
        <mat-card class="card--release" appearance="outlined">
          <mat-card-header class="release__header">
            <div class="release__meta">
              <span class="release__date">{{ post.date | date:'dd.MM.yyyy' }}</span>
            </div>
            <h2 class="release__title">{{ post.title }}</h2>
          </mat-card-header>
          <mat-card-content>
            <p class="post__excerpt">{{ post.excerpt }}</p>
          </mat-card-content>
        </mat-card>
      </a>
    }
  </section>

</section>
